import type { JointOwner, Property, Unit } from '@/core/api/models/profile';
import { normalizeAmenities } from '@/modules/property-details/services/amenityService';

/** Map GET /v1/customers/profile-details unit → app store Property (email login path). */
export function mapUnitToProperty(unit: Unit): Property {
  return {
    id: unit.unit_id,
    unitNumber: unit.unit_number,
    projectName: unit.project_name,
    buildingName: unit.building_name,
    salesOrderId: unit.salesorder_id,
    totalPrice: unit.total_price,
    paidAmount: unit.paid_amount,
    outstandingAmount: unit.outstanding_amount,
    handoverDate: unit.handover_date,
    handoverComplete: unit.handover_complete,
    spaStatus: unit.spa_status,
    bedrooms: unit.number_of_bedrooms ? Number.parseInt(unit.number_of_bedrooms, 10) : null,
    bathrooms: unit.number_of_bathrooms ?? null,
    area: unit.total_area,
    longitude: unit.longitude,
    latitude: unit.latitude,
    addressingNumber: unit.addressing_number ?? null,
    amenities: normalizeAmenities(unit.amenities),
    documents: unit.documents || [],
    jointOwners: (unit.joint_owners || []) as JointOwner[],
    buyerName: unit.buyer_name,
    isOnlinePaymentEnabled: unit.isOnlinePaymentEnabled === true,
    isADHAUnit: unit.isADHAUnit === true,
    adhaUnitStatus: unit.status?.trim() || null,
  };
}
